import { createSelectors as createBaseAvatarSelectors } from '../BaseAvatar/BaseAvatar'

export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'surface',
		label: 'Feature Background',
		selector: '& .feature-bg'
	},
	{
		name: 'surface',
		label: 'Quote Background',
		selector: '& .quote-bg'
	},
	{
		name: 'surface',
		label: 'Quote Text',
		selector: '& .quote-text'
	},

	...createBaseAvatarSelectors({
		name: 'avatar',
		label: 'Avatar',
		selector: '& .avatar'
	})

]